export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a gestionar el lote"])},
          "harvested_batches_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar lote"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      }
    }
  })
}